import { render, staticRenderFns } from "./StepFinished.vue?vue&type=template&id=be4631c2&scoped=true"
import script from "./StepFinished.vue?vue&type=script&lang=js"
export * from "./StepFinished.vue?vue&type=script&lang=js"
import style0 from "./StepFinished.vue?vue&type=style&index=0&id=be4631c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4631c2",
  null
  
)

export default component.exports